import React from 'react';

const Header = () => {
    return (
        <div style={{height: '50px', margin: "50px 0"}}>
            <img src="./img/Narwal_logo_6184fd7a-f19a-4c3f-889c-20a94e4326b0_130x.webp" alt=""  />
        </div>
    );
};

export default Header;